import React, { useContext, useEffect, useState } from 'react';
import LocaleContext from 'constants/localization';
import API from 'constants/api';

import Loading from 'components/common/Loading';
import { Button, Form } from 'react-bootstrap';

const ReportView = ({uri}) => {
  const LS = useContext(LocaleContext);  
  const [title, setTitle] = useState('');
  const [fields, setFields] = useState({});
  const [loading, setLoading] = useState(true);
  const [museumDetailsChain, setMuseumDetailsChain] = useState('');

  useEffect(() => {
    fetch(`${API.UI.REPORT_TEMPLATE}&uri=${uri}`)
      .then(res => res.json())
      .then(object => {
        setTitle(object.title);
        setFields(object.fields);
        setMuseumDetailsChain(object.museumDetailsChain);
      })
      .then(() => setLoading(false))
      .catch(e => console.log(e));
  }, []);

  const submitForm = (e) => {
    e.preventDefault();
    const body = {
      'uri': uri,
      'title': title,
      'fields': fields,
      'museumDetailsChain': museumDetailsChain
    };
    fetch('/wordReport.do', {
      method: 'POST',
      body: JSON.stringify({body}),
      headers: { 'Content-Type': 'application/json' }
    })
      .then(res => res.blob())
      .then(blob => downloadDocument(blob));
  };

  const downloadDocument = (blob) => {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = `${title}.docx`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  };

  const handleFieldChange = (e, index) => {
    let fieldsNext = {...fields};
    fieldsNext[index]['text'] = e.target.value;
    setFields(fieldsNext);
  };

  if (loading){
    return (
      <Loading/>
    );
  }

  return (
    <div>
      <h1>{title}</h1>
      <Form onSubmit={submitForm}>
        {
          Object.keys(fields).map((key, i) => {
            if (Object.prototype.hasOwnProperty.call(fields[key], 'label')) {
              return (
                <Form.Group key={i}>
                  <Form.Label>{fields[key]['label']}</Form.Label>
                  <Form.Control 
                    as="textarea" 
                    value={fields[key]['text']}
                    rows="2"
                    onChange={e => handleFieldChange(e, key)} />
                </Form.Group>
              );
            }
          })
        }
        <Button className="action-button" type="submit">
          {LS.actions.create}
        </Button>
      </Form>
    </div>
  );
};

export default ReportView;